/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventTopic } from "../../events/types/EventTopic";
import { ResourceType } from "../../commons/types/ResourceType";
import { ActorType } from "../../commons/types/ActorType";
import { Context } from "../../events/types/Context";
export const Activity = core.serialization.object({
    activity: EventTopic,
    resourceId: core.serialization.string().optional(),
    resourceType: ResourceType.optional(),
    resourceSlug: core.serialization.string().optional(),
    resourceName: core.serialization.string().optional(),
    actorId: core.serialization.string().optional(),
    actorType: ActorType.optional(),
    actorName: core.serialization.string().optional(),
    context: Context,
    payload: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    activityTime: core.serialization.date(),
});
